var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoS7CtaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#01589B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.13 31.5H33.8333C33.2145 31.5 32.621 31.7458 32.1834 32.1834C31.7458 32.621 31.5 33.2145 31.5 33.8333V39.13",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1665 17.8965V19.8332C22.1665 20.7614 22.5353 21.6516 23.1916 22.308C23.848 22.9644 24.7382 23.3332 25.6665 23.3332C26.2853 23.3332 26.8788 23.579 27.3164 24.0166C27.754 24.4542 27.9998 25.0476 27.9998 25.6665C27.9998 26.9498 29.0498 27.9998 30.3332 27.9998C30.952 27.9998 31.5455 27.754 31.9831 27.3164C32.4207 26.8788 32.6665 26.2853 32.6665 25.6665C32.6665 24.3832 33.7165 23.3332 34.9998 23.3332H38.6982",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 39.6085V35.0002C26.8333 34.3813 26.5874 33.7878 26.1498 33.3502C25.7123 32.9127 25.1188 32.6668 24.4999 32.6668C23.8811 32.6668 23.2876 32.421 22.85 31.9834C22.4124 31.5458 22.1666 30.9523 22.1666 30.3335V29.1668C22.1666 28.548 21.9208 27.9545 21.4832 27.5169C21.0456 27.0793 20.4521 26.8335 19.8333 26.8335H16.3916",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 39.6668C34.4435 39.6668 39.6668 34.4435 39.6668 28.0002C39.6668 21.5568 34.4435 16.3335 28.0002 16.3335C21.5568 16.3335 16.3335 21.5568 16.3335 28.0002C16.3335 34.4435 21.5568 39.6668 28.0002 39.6668Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoS7CtaIcon);
export default __webpack_public_path__ + "static/media/cdmoS7CtaIcon.6ed64146b8787364503676c1cb3e8b76.svg";
export { ForwardRef as ReactComponent };